module.exports = __webpack_public_path__ + "acd086b66a65af50d98ce13b7f37dbba.svg";